import React from 'react';

import NationalContacts from '../components/NationalContacts';
import fetchContent from '../helpers/backend-communication';

export default class NationalContactsPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      totalCountries: null
    };
  }
requestData(options) {
     console.log('Fetching National Points of Contact data...');
     fetchContent('npcComplete')
       .then(response => {
         this.setState({totalCountries:response.total_countries})
       })
       .catch(error => {
         console.log(error)
       });

  }

  componentDidMount() {
    this.requestData(this.props);
  }

  render() {
    return (
      <div style={{ minHeight: '600px' }}>
        <h2>
          National points of contact
        </h2>
        <p>
          National points of contact on the implementation of the
          Programme of Action and the International Tracing Instrument,
          communicated to UNODA by Member States{' '}.
          NPCs should be updated directly by Member States, whenever necessary, through updating and resubmitting their latest national reports.
        </p>

        {this.state.totalCountries !== null && (<NationalContacts totalCountries={this.state.totalCountries}/>)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/NationalContacts.js